import { render } from "./StudentSelect.vue?vue&type=template&id=9326ac62&ts=true"
import script from "./StudentSelect.vue?vue&type=script&lang=ts"
export * from "./StudentSelect.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__